// Export the async action creators directly from the constants
export {
  GET_DEEPFAKE_MEETINGS_ASYNC,
  GET_DEEPFAKE_ANALYTICS_ASYNC,
  GET_DEEPFAKE_ANALYTICS_PREVIOUS_ASYNC,
  GET_DEEPFAKE_CALL_DETAILS_ASYNC,
} from './meetingsConstants'

// Filter actions
export const setDeepfakeMeetingsFilters = (filters) => ({
  type: 'SET_DEEPFAKE_MEETINGS_FILTERS',
  payload: filters,
})

export const setDeepfakeMeetingsTimeFilter = (timeFilter) => ({
  type: 'SET_DEEPFAKE_MEETINGS_TIME_FILTER',
  payload: timeFilter,
})

export const setDeepfakeMeetingsOrdering = (ordering) => ({
  type: 'SET_DEEPFAKE_MEETINGS_ORDERING',
  payload: ordering,
})

export const setDeepfakeMeetingsPage = (page) => ({
  type: 'SET_DEEPFAKE_MEETINGS_PAGE',
  payload: page,
})

export const setDeepfakeMeetingsPageSize = (pageSize) => ({
  type: 'SET_DEEPFAKE_MEETINGS_PAGE_SIZE',
  payload: pageSize,
})

export const clearDeepfakeMeetingsFilters = () => ({
  type: 'CLEAR_DEEPFAKE_MEETINGS_FILTERS',
})

export const updateDeepfakeMeetingsLastUpdated = () => ({
  type: 'UPDATE_DEEPFAKE_MEETINGS_LAST_UPDATED',
})

export const setDeepfakeMeetingsLiveOnly = (liveOnly) => ({
  type: 'SET_DEEPFAKE_MEETINGS_LIVE_ONLY',
  payload: liveOnly,
})

// False positive actions
export const markNotDeepfake = (companyId, callParticipantId, callId, reasonText = null) => ({
  type: 'MARK_NOT_DEEPFAKE_REQUEST',
  payload: { companyId, callParticipantId, callId, reasonText },
})

export const markNotDeepfakeSuccess = (response) => ({
  type: 'MARK_NOT_DEEPFAKE_SUCCESS',
  payload: response,
})

export const markNotDeepfakeFailure = (error) => ({
  type: 'MARK_NOT_DEEPFAKE_FAILURE',
  error,
})

export const markDeepfake = (companyId, callParticipantId, callId, reasonText = null) => ({
  type: 'MARK_DEEPFAKE_REQUEST',
  payload: { companyId, callParticipantId, callId, reasonText },
})

export const markDeepfakeSuccess = (response) => ({
  type: 'MARK_DEEPFAKE_SUCCESS',
  payload: response,
})

export const markDeepfakeFailure = (error) => ({
  type: 'MARK_DEEPFAKE_FAILURE',
  error,
})
